import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router";
import { womenInfo } from "../components/womenInfo";
import { Carbon } from "../images/icons";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Women = () => {
  const [woman, setWoman] = useState("");
  const id = useParams();

  useEffect(() => {
    setWoman(womenInfo.find((item) => item.id === id.id));
  }, [woman, id]);

  return (
    <div>
      <div className="h-[600px] md:h-[400px] w-full flex flex-col items-center justify-center bg-white space-y-10">
        <div className="py-10 px-8 border-b-2 border-black">
          <h1 className="text-6xl md:text-4xl">{woman.name}</h1>
        </div>
        <div className="flex flex-col items-center">
          <h2 className="text-xl md:text-lg font-semibold w-[520px] md:w-full text-center px-10 mb-4">
            {woman.subText}
          </h2>
          <h6 className="date-lived font text-center">{woman.lived}</h6>
        </div>
      </div>
      <div className="biography grid grid-cols-2 gap-6 py-12 md:hidden">
        <div className="text-white py-32 px-24 space-y-14">
          <div className="flex flex-col items-start">
            <h1 className="py-2 border-b-2 border-white">BIOGRAPHY</h1>
            <span className="h-2 w-48 ml-6 border-b-2 border-white"></span>
          </div>
          <p className="text-2xl leading-relaxed italic">{woman.bioText}</p>
        </div>
        <div className="h-[600px] flex justify-center items-center">
          <div className="h-4/5 relative flex">
            <div className="h-[300px] w-[354px] bg-apricot self-end -mr-2 -mb-2">
              <div className="absolute bottom-0 right-0 h-[500px] w-[400px]">
                <img src={woman.image} alt="" className="h-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-10 md-min:hidden">
        <div className="p-0">
          <img src={woman.image} alt="" className="h-full" />
        </div>
        <div className="flex justify-center min-h-max px-6 text-white text-center relative">
          <div className="absolute top-1/2 flex justify-between w-full">
            <button className="h-8 w-8 bg-white rounded-full z-[800] flex items-center justify-center text-secondary text-xl shadow-md">
              <IoIosArrowBack />
            </button>
            <button className="h-8 w-8 bg-white rounded-full z-[800] flex items-center justify-center text-secondary text-xl shadow-md">
              <IoIosArrowForward />
            </button>
          </div>
          <p className="biography text-sm leading-relaxed italic px-4 py-6">
            {woman.bioText}
          </p>
        </div>
      </div>
      <div className="dive-into px-32 md:px-6 py-20 flex flex-col items-center space-y-20 md:space-y-10">
        <h1 className="text-center md:text-2xl">DIVE INTO HER LIFE</h1>
        <div className="trailer-container">
          <ReactPlayer
            className="trailer"
            url={woman.ytLink}
            controls="false"
          />
        </div>
      </div>
      <div className="dive-into px-32 md:px-0 py-20 flex flex-col items-center justify-center space-y-20 md:space-y-10">
        <h1 className="text-center md:text-2xl md:px-6">
          ARTIFACT SHE MAY HAVE USED
        </h1>
        <div className="artifact h-[600px] md:h-[530px] md:px-8 w-full flex md:flex-col items-center justify-center relative md:space-y-20">
          <div className="h-4/6 md:h-[330px] md:flex items-center justify-center">
            <img
              src={woman.artifactImg}
              alt=""
              className="md-min:h-full md:object-contain md:w-full"
            />
          </div>
          <div className="flex items-center justify-center absolute top-0 left-0 w-full h-full bg-black/60 opacity-0 hover:opacity-100 transition-all delay-150 md:hidden">
            <button className="flex items-center space-x-2 px-7 py-5 bg-secondary text-white">
              <Carbon />
              <span>EXPLORE IN 3D</span>
            </button>
          </div>
          <button className="bg-black text-white px-10 py-4 md-min:hidden">
            VIEW
          </button>
        </div>
        <div className="flex flex-col space-y-3 items-center md:items-start md:px-6">
          <h1 className="text-center md:text-start md:text-2xl">
            {woman.artifactName}
          </h1>
          <p className="text-center md:text-start w-4/6 md:w-full md:text-sm">
            {woman.artifactInfo}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Women;
